/* note!

Keep in mind the base url is "/api" by default. Meaning when you use this make sure to not add "/api" otherwise we woudl make a fetch to `/api/api`
*/

import axios from "axios";
import { toast } from "react-hot-toast";
import config from "@/config";

// use this to interact with our own API (/app/api folder) from the front-end side
const apiClient = axios.create({
  baseURL: "/api",
});

apiClient.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {
    // Always prioritize the error message from the response data
    let message = error.response?.data?.error;

    // Some endpoints return a structured error ({ code, ... }) meant to be
    // mapped/translated by the caller. Never toast a raw object.
    if (message && typeof message === "object") {
      message = message.code || null;
    }

    // Only fall back to default messages if no response error message exists
    if (!message) {
      if (error.response?.status === 401) {
        message = "Please login";
        if (!window.location.pathname.includes("language")) {
          window.url = config.auth.loginUrl;
        }
      } else if (error.response?.status === 403) {
        message = "Pick a plan to use this feature";
      } else if (error.response?.status === 404) {
        message = "Resource not found";
      } else {
        message = error.message || error.toString();
      }
    }

    error.message = message;

    // 4xx are expected validation/business failures (already toasted to the
    // user); only 5xx (or no-response network errors) warrant the
    // console.error treatment that triggers the Next.js dev overlay.
    const status = error.response?.status;
    if (!status || status >= 500) {
      console.error("API Error:", error.message);
    } else {
      console.warn("API Error:", error.message);
    }

    // Only show toast if suppressToast is not set in the request config
    if (!error.config?.suppressToast) {
      if (message) {
        toast.error(message);
      } else {
        toast.error("Something went wrong...");
      }
    }

    return Promise.reject(error);
  }
);

// Add a custom deleteWithData method for more intuitive DELETE requests with body
apiClient.deleteWithData = function (url, data, config = {}) {
  return this.delete(url, { ...config, data });
};

export default apiClient;
